import React, { useState, useEffect, useCallback } from "react";

const FillInTheBlanksDraggable = ({ sentence, options, submitted, onOptionsChange }) => {
  const parts = sentence.split(/(__add_blank__|<span[^>]*>.*?<\/span>)/);
  const placeholderIndices = parts
    .map((part, index) => (part.startsWith("<span") ? index : null))
    .filter((index) => index !== null);
  const correctAnswers = parts
    .filter((part) => part.startsWith("<span") && part.endsWith("</span>"))
    .map((part) => part.replace(/<span[^>]*>|<\/span>/g, ""));
  const initialReplacedOptions = Array(placeholderIndices.length).fill(null);
  const [replacedOptions, setReplacedOptions] = useState(initialReplacedOptions);
  const [isCorrect, setIsCorrect] = useState(Array(placeholderIndices.length).fill(false));

  const checkAnswers = useCallback(() => {
    if (submitted) {
      const newIsCorrect = replacedOptions.map(
        (option, index) => option === correctAnswers[index]
      );
      setIsCorrect(newIsCorrect);
    }
  }, [submitted, replacedOptions, correctAnswers]);

  useEffect(() => {
    checkAnswers();
  }, [submitted]);

  useEffect(() => {
    if (!submitted) {
      setReplacedOptions(initialReplacedOptions);
      setIsCorrect(Array(placeholderIndices.length).fill(false));
    }
  }, [submitted]);

  const handleDragStart = (event, option) => {
    event.dataTransfer.setData("text/plain", option);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleDrop = (event, index) => {
    if (submitted) return;
    event.preventDefault();
    const option = event.dataTransfer.getData("text/plain");
    replacePlaceholder(index, option);
  };

  const replacePlaceholder = (index, option) => {
    const newReplacedOptions = [...replacedOptions];
    newReplacedOptions[index] = option;
    setReplacedOptions(newReplacedOptions);
    onOptionsChange(newReplacedOptions);
  };

  return (
    <div>
      <p className="my-4 px-6 text-justify">
        {parts.map((part, index) => {
          if (part.startsWith("<span") && part.endsWith("</span>")) {
            const placeholderIndex = placeholderIndices.indexOf(index);
            const option = replacedOptions[placeholderIndex];

            return (
              <span
                key={index}
                onDragOver={handleDragOver}
                onDrop={(event) => handleDrop(event, placeholderIndex)}
                className={`inline-block px-10 py-3 border rounded-sm m-1 cursor-pointer ${
                  submitted
                    ? isCorrect[placeholderIndex]
                      ? 'bg-green-200'
                      : 'bg-red-200'
                    : 'bg-gray-200'
                }`}
                style={{ padding: "10px", margin: "5px 0" }}
              >
                {option !== null ? option : `__${placeholderIndex + 1}__`}
              </span>
            );
          } else if (!part.includes("__add_blank__")) {
            return <span key={index}>{part}</span>;
          } else {
            return null;
          }
        })}
      </p>

      <div className="flex flex-wrap gap-2 mt-4 px-4 py-4 sm:px-6">
        {options.map((option, index) => (
          <div
            key={index}
            draggable={!submitted}
            onDragStart={(event) => handleDragStart(event, option)}
            className="p-2 bg-blue-200 rounded-sm cursor-move"
          >
            {option}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FillInTheBlanksDraggable;
